import { ReactComponent as ArrowCircleUp } from '@/assets/icons/arrow-circle-up.svg'

export function PLGHandler({
  onMouseEnter,
  visible,
  style = {},
}: {
  onMouseEnter: ((e: React.MouseEvent<HTMLElement>) => void) | undefined
  visible: boolean
  style?: React.CSSProperties
}) {
  if (!visible) return null

  return (
    <ArrowCircleUp
      style={style}
      onMouseEnter={e => {
        onMouseEnter?.(e as unknown as React.MouseEvent<HTMLElement>)
      }}
    />
  )
}
